module.exports = __webpack_public_path__ + "static/webpack-merge-05ed8937fcdcbd649525d76562cf8ba4.png";